<script>
import NavBar from "@/components/NavBar"
import FooterSection from "@/components/FooterSection"
import PartnersPage from '@/components/PartnersPage'

export default {
  name: 'PartnersApp.vue',
  components: {
    NavBar,
    FooterSection,
    PartnersPage
  },
}
</script>

<template>
  <div>
    <NavBar />
    <PartnersPage />
    <FooterSection />
  </div>
</template>

<style lang="scss">
  @import "./../../scss/style";
</style>